module.exports = __webpack_public_path__ + "static/media/8.39af38e9.jpg";